// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1oMwN","footer":"ModalError_footer__2BsFt"};